import { lazy } from 'react';

export const AgreementsDashboardCard = lazy(() =>
  import('../../agreements/shared/widgets/widget-dashboard').then((module) => ({
    default: module.AgreementsDashboardCard,
  }))
);
export const CompaniesDashboardCard = lazy(() =>
  import('../../companies/shared/widgets/widget-dashboard').then((module) => ({
    default: module.CompaniesDashboardCard,
  }))
);
export const ContactsDashboardCard = lazy(() =>
  import('../../contacts/shared/widgets/widget-dashboard-card').then((module) => ({
    default: module.ContactsDashboardCard,
  }))
);
export const ContactUpcomingBirthdaysDashboardCard = lazy(() =>
  import('../../contacts/shared/widgets/widget-birthday').then((module) => ({
    default: module.ContactUpcomingBirthdaysDashboardCard,
  }))
);
export const SnapshotCashAvailableOnHand = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-snapshot-cash-available-on-hand').then((module) => ({
    default: module.default,
  }))
);
export const SnapshotCashReservesOnHand = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-snapshot-cash-reserves-on-hand').then((module) => ({
    default: module.default,
  }))
);
export const SnapshotCreditCardFundsAvailable = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-snapshot-credit-card-funds-available').then((module) => ({
    default: module.default,
  }))
);
export const SnapshotCreditCardDebt = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-snapshot-credit-card-debt').then((module) => ({
    default: module.default,
  }))
);
export const FinancialSnapshotItems = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-financial-snapshot-items').then((module) => ({
    default: module.default,
  }))
);
export const MonthlySalesSummary = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-monthly-sales-summary').then((module) => ({
    default: module.default,
  }))
);
export const AnnualHistoricalSales = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-annual-historical-sales').then((module) => ({
    default: module.default,
  }))
);
export const RecurringRevenueVariance = lazy(() =>
  import('../../financial-snapshot/shared/widgets/widget-recurring-revenue-variance').then((module) => ({
    default: module.default,
  }))
);
export const InventoryBelowMinimumStock = lazy(() =>
  import('../../inventories/shared/widgets/widget-inventory-minimum-stock').then((module) => ({
    default: module.default,
  }))
);
export const InventoryAssetValue = lazy(() =>
  import('../../inventories/shared/widgets/widget-inventory-asset-value').then((module) => ({
    default: module.default,
  }))
);
export const QuickCompaniesOverview = lazy(() =>
  import('../../companies/shared/widgets/widget-companies').then((module) => ({
    default: module.default,
  }))
);

export const UpcomingConferencesEventsWidget = lazy(() =>
  import('../../conference-events/shared/widgets/widget-upcoming-conferences-events').then((module) => ({
    default: module.default,
  }))
);

export const ExpiringDomainsAssociatedWithAgreementsWidget = lazy(() =>
  import('../../domains/shared/widgets/widget-expiring-domains-associated-with-agreements').then((module) => ({
    default: module.default,
  }))
);

export const TopCompetitorsSnapshot = lazy(() =>
  import('../../competitors/shared/widgets/widget-competitors').then((module) => ({
    default: module.default,
  }))
);

export const GeographicAgreementMap = lazy(() =>
  import('../../agreements/shared/widgets/widget-geographic-agreement-map').then((module) => ({
    default: module.default,
  }))
);

export const GeographicAgreementMapLoading = lazy(() =>
  import('../../agreements/shared/widgets/widget-geographic-agreement-map/loading').then((module) => ({
    default: module.Loading,
  }))
);

export const TimeOffCalendarWidget = lazy(() =>
  import('../../team-members/shared/widgets/widget-time-off').then((module) => ({
    default: module.TimeOffCalendarWidget,
  }))
);

export const TimeOffCalendarWidgetLoading = lazy(() =>
  import('../../team-members/shared/widgets/widget-time-off/loading').then((module) => ({
    default: module.TimeOffCalendarWidgetLoading,
  }))
);
export const AgreementCloseConversion = lazy(() =>
  import('../../agreements/shared/widgets/widget-agreement-close-conversion').then((module) => ({
    default: module.default,
  }))
);

export const AgreementCloseConversionLoading = lazy(() =>
  import('../../agreements/shared/widgets/widget-agreement-close-conversion/widget-loading').then((module) => ({
    default: module.Loading,
  }))
);
export const ImplementationDuration = lazy(() =>
  import('../../agreements/shared/widgets/widget-implementation-duration').then((module) => ({
    default: module.default,
  }))
);

export const ImplementationDurationLoading = lazy(() =>
  import('../../agreements/shared/widgets/widget-implementation-duration/widget-loading').then((module) => ({
    default: module.Loading,
  }))
);

export const CommissionDashboard = lazy(() =>
  import('../../team-members/shared/widgets/commissions/widget-commission-dashboard').then((module) => ({
    default: module.default,
  }))
);

export const CommissionDashboardLoading = lazy(() =>
  import('../../team-members/shared/widgets/commissions/widget-commission-dashboard').then((module) => ({
    default: module.CommissionDashboardWidgetLoading,
  }))
);

export const MileageDashboard = lazy(() =>
  import('../../team-members/shared/widgets/mileage/widget-mileage-dashboard').then((module) => ({
    default: module.default,
  }))
);

export const MileageDashboardLoading = lazy(() =>
  import('../../team-members/shared/widgets/mileage/widget-mileage-dashboard').then((module) => ({
    default: module.MileageDashboardWidgetLoading,
  }))
);

export const PartnerRevenueTailPayouts = lazy(() =>
  import('../../settings/partners/shared/widgets/widget-partner-payout').then((module) => ({
    default: module.default,
  }))
);

export const PartnerRevenueTailPayoutsLoading = lazy(() =>
  import('../../settings/partners/shared/widgets/widget-partner-payout/loading').then((module) => ({
    default: module.PartnerPayoutLoading,
  }))
);
